import { YCBConfigArray } from 'Config/types';

export type APIConfig = {
  api: {
    defaultAppVersion: number;
  };
  platformHeader: string;
};

const api: YCBConfigArray<APIConfig> = [
  {
    settings: ['main'] as const,
    api: {
      defaultAppVersion: 1000000,
    },
    platformHeader: 'web',
  },
  {
    settings: ['lite:1'],
    platformHeader: 'lite',
  },
];

export default api;
